"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--left/24.js"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".back-button {\n  display: inline;\n  margin-right: 27px;\n  vertical-align: middle; }\n  .back-button svg:hover {\n    cursor: pointer; }\n";
  const fileName = "BackButton_BackButton";
  const element = document.querySelector("style[data-sass-component='BackButton_BackButton']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const BackButton = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'back-button'
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    onClick: props.onClick
  }));
};
exports.BackButton = BackButton;
BackButton.propTypes = {
  onClick: _propTypes.default.func.isRequired
};